import { createSlice } from "@reduxjs/toolkit";

const initialBinTypeState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    bintypeForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const bintypeSlice = createSlice({
    name: "bintypes",
    initialState: initialBinTypeState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getBinTypeById
        bintypeFetched: (state, action) => {
            state.actionsLoading = false;
            state.bintypeForEdit = action.payload.bintypeForEdit;
            state.floorPlans = action.payload.bintypeForEdit.floorPlans;
            state.error = null;

        },
        // getBinTypeChart
        bintypeChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.bintypeChart = action.payload.bintypeChart;
            state.error = null;

        },
        // getBinTypeChart
        bintypeHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.bintypeChartHour = action.payload.bintypeChartHour;
            state.error = null;

        },
        // getBinTypeChart
        bintypeHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.bintypeChartHourZone = action.payload.bintypeChartHourZone;
            state.error = null;

        },
        // get list data
        bintypesFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.bintypeForEdit = undefined;
            state.floorPlans = undefined;
            state.bintypeChart = undefined;
            state.bintypeChartHour = undefined;
            state.bintypeChartHourZone = undefined;
        },
        // createBinType
        bintypeCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateBinType
        bintypeUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // bintypeDeleted
        bintypeDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
